// extracted by mini-css-extract-plugin
export default {"root":"PlasmicBrandName_root__EYgKo"};